import InfoOutlineIcon from "@mui/icons-material/InfoOutline";
import { Button, IconButton, Link, Typography } from "@mui/material";
import { useCustomModel } from "components/context/CustomProvider";
import { useState } from "react";
import CustomDialog from "../CustomDialog";
import JsonViewer from "./JsonViewer";

export const InfoButton = ({ variant, label, data, ...props }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      {variant === "link" ? (
        <Typography variant="caption" color="textSecondary" mt={0} {...props}>
          <Link variant="outlined" onClick={() => setOpen(true)}>
            {label || "Info"}
          </Link>
        </Typography>
      ) : (
        <IconButton
          variant="outlined"
          size="small"
          onClick={() => setOpen(true)}
          {...props}
        >
          <InfoOutlineIcon />
        </IconButton>
      )}
      <CustomDialog
        variant="drawer"
        open={open}
        onClose={() => setOpen(false)}
        sx={{ maxWidth: "80vw", p: 2, zIndex: 1500 }}
      >
        <CustomDialog title>Information</CustomDialog>
        <CustomDialog content>
          <JsonViewer label={"data"} data={data} defaultOpen={2} />
        </CustomDialog>
        <CustomDialog actions>
          <Button
            variant="contained"
            onClick={() => setOpen(false)}
            sx={{ mt: 2 }}
          >
            Close
          </Button>
        </CustomDialog>
      </CustomDialog>
    </>
  );
};

const ModelInfoButton = ({ modelName, variant, label }) => {
  const model = useCustomModel(modelName);
  if (!model) return null;

  return <InfoButton variant={variant} label={label} data={model} />;
};

export default ModelInfoButton;
